<template>
    <div>
        <v-row>
            <v-col cols="8">
                <v-card>
                    <v-card-title>
                        کاربران
                    </v-card-title>
                    <v-card-text>
                        <div class="container">
                            <div class="row ">
                                <v-data-table
                                        height="400"
                                        fixed-header
                                        dense
                                    hide-default-footer
                                    disable-pagination
                                    multi-sort
                                        class="margin-auto table-bordered"
                                        :headers="headers"
                                        :items="items"
                                >
                                    <template v-slot:item.operation="{ item }">

                                        <v-btn title="ویرایش" @click="edit_item(item)" outlined small color="warning">
                                            <v-icon
                                                    small
                                                    color="warning"
                                            >
                                                mdi-pencil
                                            </v-icon>
                                        </v-btn>
                                        <v-btn title="دسترسی ها" @click="select_user_permission(item)" outlined small
                                               color="error">
                                            <v-icon
                                                    small
                                                    color="primary"
                                            >
                                                mdi-eye
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-slot:item.active="{ item }">
                                        <td v-if="item.active==1">فعال</td>
                                        <td v-if="item.active==0">غیر فعال</td>
                                    </template>

                                </v-data-table>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="4" v-if="user_permission==false">
                <v-card>
                    <v-card-title>
                        افزودن کاربر جدید
                    </v-card-title>
                    <v-card-text>
                        <v-text-field
                                id="user_code"
                                dense
                                @keypress="isNumber"
                                v-model="model.code"
                                v-on:keyup.enter="another_focus('user_name')"
                                label="کد کاربر"/>
                        <v-text-field
                            dense
                            id="user_name"
                                v-model="model.name"
                                v-on:keyup.enter="another_focus('user_pass')"
                                label="نام کاربر"/>
                        <v-text-field
                                id="user_pass"
                                v-model="model.password"
                                dense
                                v-on:keyup.enter="another_focus('user_repass')"
                                label="کلمه عبور"/>
                        <v-text-field
                            dense
                            id="user_repass"
                                v-model="model.repass"
                                v-on:keyup.enter="another_focus('user_status')"
                                label="تکرار کلمه عبور"/>
                        <v-select
                                label="وضعیت کاربر"
                                id="user_status"
                                v-model="model.active"
                                :items="[{label:'فعال',value:1},{label:'غیر فعال',value:0}]"
                                item-value="value"
                                item-text="label"

                        ></v-select>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="status_form==0" color="success" id="add_user" @click="insert_data()">ثبت</v-btn>
                        <v-btn v-if="status_form!=0" color="warning" id="add_user" @click="insert_data()">ویرایش
                        </v-btn>
                        <v-btn color="warning" @click="reset_form()">انصراف</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col cols="4" v-if="user_permission==true">
                <v-card>
                    <v-card-title>
                        {{selected_user.name}}
                    </v-card-title>
                    <v-card-text>
                        <div v-for="role in roles" :key="role.id">
                            <v-checkbox style="margin: 0px" :label="role.title" :value="role.id" v-model="selected_user.user_roles"/>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="warning" id="add_user_permission" @click="insert_permission()">ویرایش
                            دسترسی
                        </v-btn>
                        <v-btn color="warning" @click="user_permission= false">انصراف</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import { bus } from '../main'
    import Vue from 'vue'

    export default {
        name: 'Users',
        components: {},
        data () {
            return {
                confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
                items: [],
                roles: [],
                selected_user: null,
                user_permission: false,
                status_form: 0,
                model: {
                    code: '',
                    name: '',
                    password: '',
                    repass: '',
                    active: 1,
                },
                headers: [
                    {
                        text: 'کد کاربر',
                        value: 'code'
                    },
                    {
                        text: 'نام کاربر',
                        value: 'name'
                    },
                    {
                        text: 'وضعیت',
                        value: 'active'
                    },
                    {
                        text: 'عملیات',
                        value: 'operation'
                    }
                ]
            }
        },
        mounted () {
            this.get_roles()
            this.get_data()
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == 'true') {
                    this.delete_item()

                } else {
                    this.status_form = 0
                }
            })
        },
        methods: {
            select_user_permission (item) {
                this.selected_user = item
                this.user_permission = true
                var roles = []
                this.selected_user.roles.forEach(function (val) {
                    roles.push(parseInt(val.role_id))
                })
                this.selected_user.user_roles = roles
            },
            reset_form () {
                this.model = {
                    code: '',
                    name: '',
                    password: '',
                    repass: '',
                    active: 1,
                }
                this.status_form = 0
            },
            edit_item (item) {
                this.model = item
                this.model.active = parseInt(this.model.active)
                this.model.repass = this.model.password
                this.status_form = item.id
            },
            get_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/users/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.items = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_roles () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/users/roles', formData, {}).then(function (response) {
                    if (response.data.error == 0) {
                        self.roles = response.data.data
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            insert_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                var url = '/api/users/insert'
                if (this.status_form != 0) {
                    url = '/api/users/update'
                    formData.append('id', this.status_form)
                }
                formData.append('code', this.model.code)
                formData.append('name', this.model.name)
                formData.append('password', this.model.password)
                formData.append('active', this.model.active)
                if (this.model.password != this.model.repass) {
                    self.$root.modal_component.show_danger_modal('خطا', 'رمز های عبور با هم مطابق نیستند')
                    return
                }
                this.axios.post(url, formData, {}).then(function (response) {
                    self.$root.modal_component.show_api_response_modals(response)

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.reset_form()
                        self.get_data()
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            insert_permission () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                var url = '/api/users/insert_role'

                formData.append('id', this.selected_user.id)
                this.selected_user.user_roles.forEach(function (val) {
                    formData.append('roles[]', val)

                })

                this.axios.post(url, formData, {}).then(function (response) {
                    self.$root.modal_component.show_api_response_modals(response)

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.reset_form()
                        self.user_permission = false;
                        self.get_data()
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            delete_item_dialog (item) {
                this.$root.modal_component.show_confirm_modal('هشدار', 'آیا مایل به حذف این ردیف هستید؟', ['تایید'], this.confirm_delete_name)
                this.status_form = item.id

            },
            delete_item () {
                const self = this
                const formData = new FormData()
                const url = '/api/users/delete'
                formData.append('id', this.status_form)

                this.axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res)
                    self.status_form = 0

                    self.get_data()

                })
                    .catch(function (error) {
                        console.log(error)
                    })
            },
        }
    }
</script>
